import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HighlightIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Highlight",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m11.38 16-2.41 2.46c-.1.1-.17.24-.17.4v.08l6.22 6.22h.1c.14 0 .26-.05.36-.12s2.42-2.42 2.42-2.42L11.37 16Zm18.45-6.68c-.71-1.73-4.31-5.37-5.92-5.37h-.03c-.27 0-.52.11-.7.28L12.22 15.18l6.53 6.53 10.96-10.95c.23-.23.43-.66.11-1.45ZM8.74 20.56l-2.62 2.63-3.8 3.84c-.55.55-.37 1 .42 1h7.6c.16 0 .31-.07.42-.17l2.63-2.63-4.65-4.68Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22.49 22.39c-.19 0-.39-.05-.57-.15-.55-.32-.73-1.01-.42-1.56l5.35-9.27c.31-.55.1-1.27-.49-1.6l-7.77-4.48c-.29-.17-.62-.22-.94-.14-.3.07-.55.26-.7.51l-5.35 9.27c-.32.55-1.02.73-1.56.42-.55-.32-.73-1.01-.42-1.56l5.35-9.27c.46-.8 1.22-1.36 2.12-1.59.89-.22 1.83-.09 2.63.38l7.76 4.48c1.68.97 2.27 3.09 1.33 4.72l-5.35 9.27c-.21.37-.6.57-.99.57ZM13.25 28.44H3a1.14 1.14 0 1 1 0-2.28h10.25a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.25 28.44c-.19 0-.39-.05-.57-.15-.55-.32-.73-1.01-.42-1.56a6.13 6.13 0 0 1 7.33-2.72L22 19.83c.32-.55 1.01-.73 1.56-.42.55.32.73 1.01.42 1.56l-2.93 5.08c-.32.55-1.02.73-1.56.42-.89-.51-1.93-.65-2.92-.38s-1.82.9-2.33 1.79c-.21.37-.6.57-.99.57ZM8.93 28.44c-.19 0-.39-.05-.57-.15-.55-.32-.73-1.01-.42-1.56l1.08-1.87c.51-.89.65-1.93.39-2.92-.27-.99-.9-1.82-1.79-2.33a1.15 1.15 0 0 1-.42-1.56l2.93-5.08a1.142 1.142 0 1 1 1.98 1.14L9.7 18.29c.93.8 1.6 1.85 1.92 3.06.42 1.58.21 3.23-.61 4.65l-1.08 1.87c-.21.37-.6.57-.99.57Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22.14 23.02c-.19 0-.39-.05-.57-.15l-7.92-4.57a1.142 1.142 0 1 1 1.14-1.98l7.92 4.57c.55.32.73 1.01.42 1.56-.21.37-.6.57-.99.57"
      })]
    })
  }));
};
HighlightIcon.displayName = 'HighlightIcon';